import { Box, CircularProgress } from '@material-ui/core'

const LoadingBox = () => {
  return (
    <Box
      display="flex"
      width="100%"
      minHeight="700px"
      justifyContent="center"
      alignItems="center"
    >
      <CircularProgress />
    </Box>
  )
}

export default LoadingBox
